import * as React from "react";

import "./PercentageBar.scss";

interface PercentageBarProps {
    value: number;
    total: number;
    width: any;
    height: any;
    backgroundColor?: string;
    dynamicBarColor?: (percentage: number) => string;
    barColor?: string;
}

export class PercentageBar extends React.Component<PercentageBarProps, any> {

    constructor(props) {
        super(props);
    }

    public render() {
        const total = Math.max(this.props.total, this.props.value);
        const percentage = (this.props.value * 100) / total;
        const originalPercentage = (this.props.value * 100) / this.props.total;
        return (
            <>
                <div
                    className={"percentage-bar-background"}
                    style={{
                        width: this.props.width + (typeof this.props.width === "number" ? "px" : ""),
                        height: this.props.height + (typeof this.props.height === "number" ? "px" : ""),
                        backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : "var(--danfoss-web-dim-grey)",
                    }}
                >
                    <div
                        className={"percentage-bar-foreground bar-status"}
                        style={{
                            width: percentage + "%",
                            height: "100%",
                            backgroundColor: this.props.dynamicBarColor ?
                                this.props.dynamicBarColor(percentage)
                                : (this.props.barColor ? this.props.barColor : "rgb( 0, 255, 0)"),
                        }}
                    />
                    <p className={"percentage-value"}>
                        {/* tslint:disable-next-line:max-line-length */}
                        {this.props.value !== null ? originalPercentage.toFixed(1) + "%" : "N/D"/*TODO: Not defined => cercare configurazione*/}
                    </p>
                </div>
            </>
        );
    }
}
